import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { User } from '../_models';
import { HttpHeaders } from '@angular/common/http';
import { ListTest } from '../interface/testinterface'
import { Observable } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class ChangePasswordService {
	constructor(private http: HttpClient) {}
	getchangepassword(currentpassword:any, newpassword:any) {
		const httpOptions = {
			headers: new HttpHeaders({
				'currentpassword': "" + currentpassword + "",
				'newpassword': "" + newpassword + "",
				'confirmpassword': "" + newpassword + ""
			})
		}
		return this.http.post < any > (environment.url + `changePassword`, '', httpOptions)
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof Error) {
			const errMessage = error.error.message;
			return Observable.throw(errMessage);
		}
		return Observable.throw(error || 'Node.js server error');
	}
}


// WEBPACK FOOTER //
// ./src/app/_services/changePassword.service.ts